import { isOnServer } from '@shared/constants/util'
import { queryOptions } from '@tanstack/react-query'
import { type GuestUserParams } from '@/features/account/services/GuestUser/types'
import { fetchGuestParams } from '@/features/account/services/GuestUser/fetchers'
import { GUEST_PARAMS_QUERY_KEY } from '@/features/account/services/GuestUser/constants'

export const guestParamsQueryOptions = queryOptions({
  queryKey: GUEST_PARAMS_QUERY_KEY,
  queryFn: (): Promise<GuestUserParams> => {
    if (isOnServer()) {
      throw new Error('guestParamsQueryOptions queryFn should not be called on the server')
    }
    return fetchGuestParams()
  },
  staleTime: Infinity,
  gcTime: Infinity,
})
